import React from 'react';
import { connect } from 'react-redux';
import {
    fetchOrgUnitHierarchy,
    fetchSelectedOrgUnitDetails
} from './../../reduxFiles/actionTypes';

import { ToastContainer, toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { Header, Item, Icon, Grid, Segment, Input} from 'semantic-ui-react';
import OrgUnitHierarchy from './components/OrgUnitHierarchy';
import OrgUnitParent from './components/OrgUnitParent';
import OrgUnitType from './components/OrgUnitType';
import OrgUnitStaff from './components/OrgUnitStaff';
import OrgUnitContact from './components/OrgUnitContact';
import AddressItem from './components/OrgUnitAddress';

import axios from 'axios';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class OrganizationalUnit extends React.Component {
    constructor(props) {
        super(props);
        this.onOrgUnitClicked = this.onOrgUnitClicked.bind(this);
    }

    componentDidMount() {
        this.getHierarchy();
        const { selectedOrgUnit } = this.props;
        let id;
        if (selectedOrgUnit.orgUnitDetails) {
            id = selectedOrgUnit.orgUnitDetails.id;
            this.getDetails(id);
        }
    }

    getHierarchy() {
        this.props.dispatch(fetchOrgUnitHierarchy());
    }

    getDetails(id) {
        this.props.dispatch(fetchSelectedOrgUnitDetails(id));
    }

    onOrgUnitClicked(event, data) {
        event.stopPropagation();
        this.getDetails(data.value);
    }

    render() {
        // TODO emir: does form use CSRF?
        const { selectedOrgUnit, orgUnitHierarchy } = this.props;
        if (orgUnitHierarchy.error) {
            toast(<FormattedMessage id="orgUnitDetailed.errors.gettingHierarchy" />);
        }
        if (selectedOrgUnit.error) {
            toast(<FormattedMessage id="orgUnitDetailed.errors.gettingOrgUnitDetails" />);
        }

        return (
            <div>
                <Grid columns={2} divided stackable>
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Header
                                as="h1"
                                content={<FormattedMessage id="orgUnitDetailed.orgUnits" />}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Segment loading={orgUnitHierarchy.items.length === 0 && orgUnitHierarchy.isFetching} style={{ height: 'calc(100vh - 225px)' }}>
                                {orgUnitHierarchy.items.length && <OrgUnitHierarchy orgUnitHierarchy={orgUnitHierarchy.items} onOrgUnitClicked={this.onOrgUnitClicked} />}
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment loading={selectedOrgUnit.isFetching} style={{ height: 'calc(100vh - 225px)' }}>
                                {selectedOrgUnit.orgUnitDetails && <div style={{ height: '100%', overflow: 'scroll' }}>
                                    <OrgUnitTitleContainer title={selectedOrgUnit.orgUnitDetails.name} orgUnitId={selectedOrgUnit.orgUnitDetails.id} />
                                    <Item.Group divided>
                                        {selectedOrgUnit.orgUnitDetails.parents && selectedOrgUnit.orgUnitDetails.parents.length > 0 && <OrgUnitParent orgUnitId={selectedOrgUnit.orgUnitDetails.id} parents={selectedOrgUnit.orgUnitDetails.parents} onOrgUnitClicked={this.onOrgUnitClicked} />}
                                        <OrgUnitType types={selectedOrgUnit.orgUnitDetails.organizationalUnitTypesName} orgUnitId={selectedOrgUnit.orgUnitDetails.id} />
                                        <OrgUnitStaff staff={selectedOrgUnit.orgUnitDetails.employees} hasType={selectedOrgUnit.orgUnitDetails.organizationalUnitTypesName.length} orgUnitId={selectedOrgUnit.orgUnitDetails.id} />
                                        <AddressItem addresses={selectedOrgUnit.orgUnitDetails.addresses} orgUnitId={selectedOrgUnit.orgUnitDetails.id} />
                                        <OrgUnitContact contacts={selectedOrgUnit.orgUnitDetails.contacts} orgUnitId={selectedOrgUnit.orgUnitDetails.id} />
                                    </Item.Group>
                                </div>}
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

class OrgUnitTitlePresentational extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditVisibile: 'hidden',
            showEdit: false,
            name: this.props.title
        };
        this.changeTitle = this.changeTitle.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.title !== nextProps.title) {
            this.setState({
                isEditVisibile: 'hidden',
                showEdit: false,
                name: nextProps.title
            });
        }
    }

    changeTitle() {
        axios.put(`/organizational-units/${this.props.orgUnitId}`, { name: this.state.name })
            .then(
                response => {
                    this.props.dispatch(fetchOrgUnitHierarchy());
                    this.props.dispatch(fetchSelectedOrgUnitDetails(this.props.orgUnitId));
                },
                error => {
                    toast(<FormattedMessage id="orgUnitDetailed.errors.changeName" />);
                    this.setState({
                        isEditVisibile: 'hidden',
                        showEdit: false,
                        name: this.props.title
                    });
                }
            );
    }

    handleChange(e, { name, value }) {
        this.setState({ [name]: value });
    }

    render() {
        const { isEditVisibile, showEdit } = this.state;
        const { title } = this.props;
        const render = !showEdit ?
            (
                <div
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    onMouseOver={() => { this.setState({ isEditVisibile: 'visible' }); }}
                    onMouseOut={() => { this.setState({ isEditVisibile: 'hidden' }); }}
                >
                    <div>
                        <Header as="h2">{title}</Header>
                    </div>
                    <div style={{ display: 'flex', visibility: isEditVisibile }}>
                        <Icon circular name="edit" onClick={() => { this.setState({ showEdit: true }); }} />
                    </div>
                </div>
            )
            : (<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ width: '100%', marginRight: '5px' }}>
                    <Input name="name" size="big" fluid value={this.state.name} onChange={this.handleChange} />
                </div>
                <div style={{ display: 'flex' }}>
                    <Icon circular name="check" onClick={() => { this.changeTitle(); }} />
                </div>
            </div>);
        return (
            <div>
                {render}
            </div>
        );
    }
}

const OrgUnitTitleContainer = connect()(OrgUnitTitlePresentational);

function mapStateToProps(state) {
    return {
        selectedOrgUnit: state.ui.orgUnitsView.selectedOrgUnit,
        orgUnitHierarchy: state.data.orgUnitHierarchy
    };
}

export default connect(mapStateToProps)(OrganizationalUnit);



// WEBPACK FOOTER //
// ./src/views/OrganizationalUnit/OrganizationalUnit.js